import { Framework } from '@/framework';

/**
 * 舞台快捷操作
 */
export class QuickStageOperate extends Framework {
    private quickOperateEvent = 'stage-quick-event';

    /**
     * 快捷操作
     */
    onQuickClick(fn: (type: string, isToggleMenu?: boolean) => void) {
        return this.framework.service.events.on(this.quickOperateEvent, fn);
    }

    /**
     * 触发快捷操作
     */
    emitQuickClick(type: string, isToggleMenu?: boolean) {
        this.framework.service.events.emit(this.quickOperateEvent, type, isToggleMenu);
        return this;
    }

    delete(stageIndex) {
        this.framework.service.stage.delete(stageIndex);
        return this;
    }

    async clone(stageIndex) {
        await this.framework.service.stage.clone(stageIndex);
        return this;
    }

    async create(stageIndex, incomeExtraInfo, inheritBgInfo, masterPage) {
        await this.framework.service.stage.create(stageIndex, incomeExtraInfo, inheritBgInfo, masterPage);
        return this;
    }

    swapStages(stagesIndex: number[], destIndex: number, sourceIndex: number) {
        this.framework.service.stage.swapStages(stagesIndex, destIndex, sourceIndex);
        return this;
    }

    up() {
        const activeIndex = this.framework.service.frame.getActiveIndex();
        if (activeIndex === 0) return;
        const isLongImageMode = this.framework.service.edgelessCanvas.isLongImageMode;
        this.framework.service.frame.delActiveLayer();
        if (isLongImageMode) {
            this.swapStages([activeIndex], activeIndex - 1, activeIndex);
            this.framework.service.frame.scrollToActiveFrame();
        } else {
            this.framework.service.frame.setActiveIndex(activeIndex - 1);
            this.framework.service.frame.scrollToActiveFrame();
        }
        return this;
    }

    down() {
        const activeIndex = this.framework.service.frame.getActiveIndex();
        const count = this.framework.service.frame.getFrameIdsLength();
        if (activeIndex === count - 1) return;
        const isLongImageMode = this.framework.service.edgelessCanvas.isLongImageMode;
        this.framework.service.frame.delActiveLayer();
        if (isLongImageMode) {
            this.swapStages([activeIndex], activeIndex + 1, activeIndex);
            this.framework.service.frame.scrollToActiveFrame();
        } else {
            this.framework.service.frame.setActiveIndex(activeIndex + 1);
            this.framework.service.frame.scrollToActiveFrame();
        }
        return this;
    }

    setStageSelection() {
        const stageIndex = this.framework.service.frame.getActiveIndex();
        this.framework.service.frame.setFrameSelection([stageIndex]);
        return this;
    }
}
